import {UserFormController} from './user_form.controller.js';
import {UsersController} from './users.controller.js';

function usersConfig($stateProvider) {

	$stateProvider
		.state('settings.users', {
			url: '/users',
			templateUrl: 'states/settings/tabs/users/users.html',
			controller: 'UsersController as Users',
			params: {
				title: 'Users'
			}
		})
		.state('settings.users.new', {
			url: '/users/new',
			parent: 'settings',
			templateUrl: 'states/settings/tabs/users/user_form.html',
			controller: 'UserFormController as UserForm',
			params: {
				title: 'Create User'
			}
		})
		.state('settings.users.edit', {
			url: '/users/{userName}/edit',
			parent: 'settings',
			templateUrl: 'states/settings/tabs/users/user_form.html',
			controller: 'UserFormController as UserForm',
			params: {
				title: 'Edit User'
			}
        });

}

export default angular.module('users', [])
                      .config(usersConfig)
                      .controller('UsersController', UsersController)
                      .controller('UserFormController', UserFormController)


// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/users/users.module.js